import { useEffect, useState } from 'react'
import api from '../services/api'

interface OperacaoItem {
  ope_cod: string
  ope_des: string
}

interface OperacaoDetalhe {
  ope_cod: string
  ope_des: string
  ope_codi1: number | null; ope_codi2: number | null; ope_codi3: number | null
  ope_codf1: number | null; ope_codf2: number | null; ope_codf3: number | null
  ope_ntvori: string
  ope_infmot: string
}

const NOVA_OPERACAO: OperacaoDetalhe = {
  ope_cod: '',
  ope_des: '',
  ope_codi1: null, ope_codi2: null, ope_codi3: null,
  ope_codf1: null, ope_codf2: null, ope_codf3: null,
  ope_ntvori: 'N',
  ope_infmot: 'N',
}

function Campo({ label, width, children }: { label: string; width?: number | string; children: React.ReactNode }) {
  return (
    <div className="field-cad" style={{ width }}>
      <label style={{ display: 'block', minHeight: '1.1rem', lineHeight: 1.2 }}>{label}</label>
      {children}
    </div>
  )
}

export default function OperacoesComerciais() {
  const [lista, setLista] = useState<OperacaoItem[]>([])
  const [busca, setBusca] = useState('')
  const [carregandoLista, setCarregandoLista] = useState(false)
  const [selecionado, setSelecionado] = useState<OperacaoDetalhe | null>(null)
  const [carregandoDetalhe, setCarregandoDetalhe] = useState(false)
  const [modoCriar, setModoCriar] = useState(false)
  const [form, setForm] = useState<OperacaoDetalhe | null>(null)
  const [salvando, setSalvando] = useState(false)
  const [msgSalvar, setMsgSalvar] = useState<{ texto: string; ok: boolean } | null>(null)

  async function carregarLista(termo: string) {
    setCarregandoLista(true)
    try {
      const r = await api.get('/operacoes-comerciais-cad', { params: termo ? { busca: termo } : {} })
      setLista(r.data)
    } finally {
      setCarregandoLista(false)
    }
  }

  useEffect(() => { carregarLista('') }, [])
  useEffect(() => {
    const t = setTimeout(() => carregarLista(busca), 350)
    return () => clearTimeout(t)
  }, [busca])

  async function selecionar(cod: string) {
    setCarregandoDetalhe(true)
    setModoCriar(false)
    setMsgSalvar(null)
    try {
      const r = await api.get(`/operacoes-comerciais-cad/${cod}`)
      setSelecionado(r.data)
      setForm(r.data)
    } finally {
      setCarregandoDetalhe(false)
    }
  }

  function nova() {
    setSelecionado(null)
    setModoCriar(true)
    setForm({ ...NOVA_OPERACAO })
    setMsgSalvar(null)
  }

  function setCampo<K extends keyof OperacaoDetalhe>(campo: K, valor: OperacaoDetalhe[K]) {
    setForm(f => f && { ...f, [campo]: valor })
  }

  async function salvar() {
    if (!form) return
    setSalvando(true)
    setMsgSalvar(null)
    try {
      if (modoCriar) {
        const r = await api.post('/operacoes-comerciais-cad', form)
        setMsgSalvar({ texto: 'Operação criada com sucesso.', ok: true })
        setModoCriar(false)
        await selecionar(r.data.ope_cod)
      } else if (selecionado) {
        await api.put(`/operacoes-comerciais-cad/${selecionado.ope_cod}`, form)
        setMsgSalvar({ texto: 'Alterações salvas com sucesso.', ok: true })
        await selecionar(selecionado.ope_cod)
      }
      await carregarLista(busca)
    } catch (e: any) {
      setMsgSalvar({ texto: e?.response?.data?.error || 'Erro ao salvar.', ok: false })
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      {/* Lista */}
      <div className="card" style={{ width: 320, flexShrink: 0 }}>
        <h3 style={{
          fontSize: '1rem', fontWeight: 700, marginBottom: '0.9rem', color: '#1a6ea8',
          paddingBottom: '0.6rem', borderBottom: '2px solid #eff6ff',
        }}>
          Operações Comerciais
        </h3>

        <div style={{ display: 'flex', gap: 8, marginBottom: '0.75rem', alignItems: 'center' }}>
          <div className="field" style={{ flex: 1 }}>
            <input
              type="text"
              placeholder="Código ou descrição..."
              value={busca}
              onChange={e => setBusca(e.target.value)}
            />
          </div>
          <button className="btn btn-primary btn-sm" onClick={nova} title="Nova operação comercial">+ Nova</button>
        </div>

        {carregandoLista && <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Carregando...</p>}
        {!carregandoLista && lista.length === 0 && (
          <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Nenhuma operação encontrada.</p>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 560, overflowY: 'auto' }}>
          {lista.map(o => {
            const ativo = selecionado?.ope_cod === o.ope_cod
            return (
              <button
                key={o.ope_cod}
                onClick={() => selecionar(o.ope_cod)}
                style={{
                  textAlign: 'left', border: '1px solid #e5e7eb', borderLeft: '4px solid #1a6ea8',
                  borderRadius: 6, padding: '8px 10px', cursor: 'pointer',
                  background: ativo ? '#eff6ff' : '#f8fafc',
                  borderColor: ativo ? '#1a6ea8' : '#e5e7eb',
                }}
              >
                <div style={{ fontWeight: 700, fontSize: '0.82rem' }}>{o.ope_cod}</div>
                <div style={{ fontSize: '0.8rem', color: '#374151', marginTop: 3 }}>{o.ope_des}</div>
              </button>
            )
          })}
        </div>
      </div>

      {/* Detalhe */}
      <div className="card" style={{ flex: 1, minWidth: 0 }}>
        {!selecionado && !modoCriar && !carregandoDetalhe && (
          <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>
            Selecione uma operação na lista ao lado, ou clique em "+ Nova".
          </p>
        )}

        {carregandoDetalhe && <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Carregando detalhes...</p>}

        {(selecionado || modoCriar) && form && !carregandoDetalhe && (
          <>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
              marginBottom: '0.6rem', paddingBottom: '0.5rem', borderBottom: '2px solid #eff6ff',
            }}>
              <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a6ea8' }}>
                {modoCriar ? 'Nova Operação Comercial' : `${selecionado?.ope_cod} — ${selecionado?.ope_des}`}
              </h3>
            </div>

            <div style={{
              background: '#f7faff', border: '1px solid #eef0f4', borderLeft: '4px solid #1a6ea8',
              borderRadius: '0.5rem', padding: '0.55rem 0.85rem', marginBottom: '0.55rem',
              display: 'flex', flexWrap: 'wrap', gap: '0.4rem 0.8rem', alignItems: 'flex-end',
            }}>
              <Campo label="Código da operação" width={90}>
                {modoCriar ? (
                  <input type="text" maxLength={3} value={form.ope_cod}
                    onChange={e => setCampo('ope_cod', e.target.value.toUpperCase())} />
                ) : (
                  <input type="text" value={selecionado?.ope_cod ?? ''} readOnly disabled />
                )}
              </Campo>
              <Campo label="Descrição" width={210}>
                <input type="text" maxLength={20} value={form.ope_des} onChange={e => setCampo('ope_des', e.target.value)} />
              </Campo>
            </div>

            <div style={{
              background: '#fafafa', border: '1px solid #eef0f4', borderLeft: '4px solid #6b7280',
              borderRadius: '0.5rem', padding: '0.55rem 0.85rem', marginBottom: '0.55rem',
            }}>
              <h4 style={{
                fontSize: '0.68rem', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase',
                letterSpacing: '0.05em', marginBottom: '0.5rem',
              }}>
                Natureza de Operação — Faixas
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                {([
                  { label: 'Faixa 1', de: 'ope_codi1', ate: 'ope_codi2' },
                  { label: 'Faixa 2', de: 'ope_codi3', ate: 'ope_codf1' },
                  { label: 'Faixa 3', de: 'ope_codf2', ate: 'ope_codf3' },
                ] as const).map(f => (
                  <div key={f.label} style={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem' }}>
                    <span style={{ fontSize: '0.78rem', color: '#6b7280', width: 55 }}>{f.label}</span>
                    <Campo label="De" width={90}>
                      <input type="number" value={form[f.de] ?? ''}
                        onChange={e => setCampo(f.de, e.target.value === '' ? null : Number(e.target.value))} />
                    </Campo>
                    <Campo label="Até" width={90}>
                      <input type="number" value={form[f.ate] ?? ''}
                        onChange={e => setCampo(f.ate, e.target.value === '' ? null : Number(e.target.value))} />
                    </Campo>
                  </div>
                ))}
              </div>
            </div>

            <div style={{
              background: '#fff8f2', border: '1px solid #eef0f4', borderLeft: '4px solid #f07820',
              borderRadius: '0.5rem', padding: '0.55rem 0.85rem', marginBottom: '0.55rem',
              display: 'flex', flexWrap: 'wrap', gap: '0.4rem 0.8rem', alignItems: 'flex-end',
            }}>
              <h4 style={{
                fontSize: '0.68rem', fontWeight: 700, color: '#f07820', textTransform: 'uppercase',
                letterSpacing: '0.05em', width: '100%', marginBottom: '0.2rem',
              }}>
                Na Devolução
              </h4>
              <Campo label="Exige Nota da Origem" width={170}>
                <select value={form.ope_ntvori} onChange={e => setCampo('ope_ntvori', e.target.value)}>
                  <option value="N">Não</option>
                  <option value="S">Sim</option>
                </select>
              </Campo>
              <Campo label="Exige Cód. do Motivo" width={170}>
                <select value={form.ope_infmot} onChange={e => setCampo('ope_infmot', e.target.value)}>
                  <option value="N">Não</option>
                  <option value="S">Sim</option>
                </select>
              </Campo>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
                {salvando ? 'Salvando...' : modoCriar ? 'Criar operação' : 'Salvar alterações'}
              </button>
              {msgSalvar && (
                <span style={{
                  fontSize: '0.8rem', fontWeight: 600, padding: '0.35rem 0.8rem', borderRadius: 6,
                  background: msgSalvar.ok ? '#d1fae5' : '#fee2e2',
                  color: msgSalvar.ok ? '#065f46' : '#991b1b',
                }}>
                  {msgSalvar.texto}
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
